import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction } from '~/rage';
import { IModalStateDefault, InputAction } from '~/shared';
import { ModalButton } from '../ModalButton';
import { StyledButtonsContainer, StyledModalBody } from './ModalDefault.styled';

const ModalDefault: React.FC<{ state: IModalStateDefault }> = ({ state }) => {
	useInputAction(InputAction.CommonMenuAccept, () => {
		rage.modal.replyToCurrentModal({ isAccepted: true });
	});

	useInputAction(InputAction.CommonMenuClose, () => {
		rage.modal.replyToCurrentModal({ isAccepted: false });
	});

	return (
		<StyledModalBody>
			<Text>{state?.text}</Text>
			<StyledButtonsContainer>
				<ModalButton
					$type={state?.cancelButton.color}
					onClick={() => {
						rage.modal.replyToCurrentModal({ isAccepted: false });
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					{state?.cancelButton.text}
				</ModalButton>
				<ModalButton
					$type={state?.acceptButton.color}
					onClick={() => {
						rage.modal.replyToCurrentModal({ isAccepted: true });
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					{state?.acceptButton.text}
				</ModalButton>
			</StyledButtonsContainer>
		</StyledModalBody>
	);
};

export { ModalDefault };
